import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';
import * as dates from '@simplybenefits/sb-dates';
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
    TextInput,
    Text,
    Button,
    Services,
    NumberInput,
    FormModal,
    DateInput,
    Loader,
    Container,
    ContentSmall,
    Title,
    Theme,
    Checkbox,
    i18n,
    tokens,
    localizationMaps
} from '@simplybenefits/sb-ui-library';

import PersonBlock from './PersonBlock';
import { addBeneficiary, editBeneficiary, removeBeneficiary } from '../../actions/user';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

class Beneficiaries extends PureComponent {
    state = {
        firstname: '',
        lastname: '',
        birthdate: this.props.birthdate ? Services.dates.formatIncomingDate(this.props.birthdate) : '',
        relationship: '',
        shares: '',
        type: '',
        beneficiaryID: null,
        password: '',
        dialogOpen: false,
        isEdit: false,
        primary: this.props.primary || [],
        contingent: this.props.contingent || [],
        hasSpouse: false,
        options: Services.selectFieldOptions.optionsWithoutSpouse(),
        confirmPasswordModalOpen: false,
        deleteModalOpen: false,
        beneficiaryToRemoveID: false,
        visibility: false,
        signage: {
            name: '',
            signature: '',
            acceptedTerms: false,
            timestampOfAcceptance: null,
            datedOn: null
        }
    };

    componentDidMount() {
        // check if they have assigned a spouse beneficiary already
        this.props.primary.some((beneficiary) => {
            if (beneficiary.relationship === 'Spouse') {
                this.setState({
                    hasSpouse: beneficiary.beneficiaryID
                });

                return true;
            }

            return false;
        });

        this.props.contingent.some((beneficiary) => {
            if (beneficiary.relationship === 'Spouse') {
                this.setState({
                    hasSpouse: beneficiary.beneficiaryID
                });

                return true;
            }

            return false;
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            primary: nextProps.primary,
            contingent: nextProps.contingent
        });
    }

    _close = () => {
        this.setState({
            firstname: '',
            lastname: '',
            relationship: '',
            shares: '',
            type: '',
            birthdate: '',
            password: '',
            beneficiaryID: null,
            firstnameError: null,
            lastnameError: null,
            relationshipError: null,
            typeError: null,
            sharesError: null,
            passwordError: null,
            beneficiaryToRemoveID: false,
            dialogOpen: false,
            deleteModalOpen: false,
            signage: {
                name: '',
                signature: '',
                acceptedTerms: false,
                timestampOfAcceptance: null,
                datedOn: null
            }
        });
    };

    _handleSelectChange = (type, event, id) => {
        if (event.target.value === 'Spouse') {
            this.setState({
                hasSpouse: id
            });
        }

        this._handleInputChange(type, event);
    };

    _handleSignageChange = (type, value) => {
        if (type === 'acceptedTerms' && value === true) {
            this.setState({
                signage: {
                    ...this.state.signage,
                    acceptedTerms: true,
                    timestampOfAcceptance: dates.getUTC()
                }
            });

            return null;
        }

        this.setState({
            signage: {
                ...this.state.signage,
                [type]: value
            }
        });

        return null;
    };

    _onBlur = async (type) => {
        this.setState({
            [`${ type }Error`]: await Services.validateInput(type, this.state[type], i18n.locale)
        });
    };

    // eslint-disable-next-line consistent-return
    _handleInputChange = (type, event) => {
        if (type === "shares") {
            this.setState({
                [type]: event.target.value
            });

            return null;
        }

            
        this.setState({
            [type]: event.target.value.toString()
        });
    };

    _handleSharesChange = (beneficiaryID, event) => {
        this.setState({
            primary: this.state.primary.map((beneficiary) => {
                if (beneficiary.beneficiaryID === beneficiaryID) {
                    return {
                        ...beneficiary,
                        shares: event.target.value
                    };
                }

                return beneficiary;
            }),
            contingent: this.state.contingent.map((beneficiary) => {
                if (beneficiary.beneficiaryID === beneficiaryID) {
                    return {
                        ...beneficiary,
                        shares: event.target.value
                    };
                }

                return beneficiary;
            })
        });
    };

    _checkShares = (checkContingent = false) => {
        let total = Number(this.state.shares);

        if (checkContingent) {
            this.state.contingent.map((beneficiary) => {
                if (beneficiary.beneficiaryID !== this.state.beneficiaryID) {
                    total = Number(total) + Number(beneficiary.shares);
                }

                return true;
            });
        } else {
            this.state.primary.map((beneficiary) => {
                if (beneficiary.beneficiaryID !== this.state.beneficiaryID) {
                    total = Number(total) + Number(beneficiary.shares);
                }

                return true;
            });
        }

        return Number(total) === 100;
    };

    _validateForm = async () => {
        const { firstname, lastname, shares, relationship, birthdate, type } = this.state;

        const firstnameError = await Services.validateInput('firstname', firstname);
        const lastnameError = await Services.validateInput('lastname', lastname);
        const sharesError = await Services.validateInput('shares', shares);
        const typeError = await Services.validateInput('checkEmpty', type);
        let birthdateError = await Services.validateInput('birthdate', birthdate, i18n.locale);
        const relationshipError = await Services.validateInput('relationship', relationship);

        // Check to see if the new Beneficiary is underage.
        const jsBirthdate = dates.getUTC(Services.dates.formatOutgoingDate(birthdate));
        const age = Math.floor((dates.getUTC() - jsBirthdate) / (60 * 60 * 24 * 365));

        // If the birthday is underage and there is no Trustee we must show an error
        if (age < 18 && !this.props.trustee) {
            birthdateError = i18n.t(tokens.labels.beneficiaries.beneficiaryUnderEighteenError);
        }


        this.setState({
            firstnameError,
            lastnameError,
            sharesError,
            relationshipError,
            birthdateError,
            typeError
        });

        if (
            firstnameError ||
            lastnameError ||
            sharesError ||
            relationshipError ||
            birthdateError ||
            typeError
        ) {
            return false;
        }

        return this._showConfirmPasswordDialog();
    };

    _openAddModal = (isContingent = false) => {
        let options = Services.selectFieldOptions.optionsWithoutSpouse();

        if (!this.state.hasSpouse) {
            options = [ ...Services.selectFieldOptions.optionsWithSpouse(), i18n.t(tokens.labels.account.other) ];
        }

        this.setState({
            firstname: '',
            lastname: '',
            relationship: '',
            type: '',
            shares: '',
            birthdate: '',
            isEdit: false,
            isContingent,
            options,
            firstnameError: false,
            lastnameError: false,
            sharesError: false,
            relationshipError: false,
            typeError: false,
            ageDisclaimer: false,
            confirmPasswordModalOpen: false,
            beneficiaryToRemoveID: false,
            dialogOpen: true,
            password: '',
            signage: {
                name: '',
                signature: '',
                acceptedTerms: false,
                timestampOfAcceptance: null,
                datedOn: null
            }
        });
    };

    _openEditModal = async (beneficiary, isContingent) => {
        let options = Services.selectFieldOptions.optionsWithoutSpouse();

        if (!this.state.hasSpouse || this.state.hasSpouse === beneficiary.beneficiaryID) {
            options = [ ...Services.selectFieldOptions.optionsWithSpouse(), i18n.t(tokens.labels.account.other) ];
        }

        await this.setState({
            beneficiaryID: beneficiary.beneficiaryID,
            firstname: beneficiary.firstname,
            lastname: beneficiary.lastname,
            relationship: localizationMaps.fromEnglish("relationships", beneficiary.relationship),
            type: localizationMaps.fromEnglish("beneficiariesOptions", beneficiary.type),
            shares: beneficiary.shares,
            birthdate: beneficiary.birthdate ? Services.dates.formatIncomingDate(beneficiary.birthdate) : '',
            firstnameError: false,
            lastnameError: false,
            sharesError: false,
            birthdateError: false,
            relationshipError: false,
            typeError: false,
            isEdit: true,
            totalShares: 0,
            dialogOpen: true,
            ageDisclaimer: false,
            confirmPasswordModalOpen: false,
            options,
            isContingent,
            password: '',
            signage: {
                name: '',
                signature: '',
                acceptedTerms: false,
                timestampOfAcceptance: null,
                datedOn: null
            }
        });
    };

    _toggleVisibility = () => {
        this.setState({
            visibility: !this.state.visibility
        });
    };

    _showConfirmPasswordDialog = async (isDelete = false) => {
        let sharesValid = true;

        if (this.state.isContingent && (!isDelete || this.props.contingent.length > 1)) {
            sharesValid = await this._checkShares(true);
        } else if (!isDelete || this.props.primary.length > 1) {
            sharesValid = await this._checkShares(false);
        }

        const beneficiaryType = this.state.isContingent ? i18n.t(tokens.labels.beneficiaries.contingent) : i18n.t(tokens.labels.beneficiaries.primary);

        if (!sharesValid) {
            this.setState({
                sharesError: i18n.t(tokens.labels.beneficiaries.sharesMustEqualError, { beneficiaryType })
            });

            return;
        }

        this.setState({
            confirmPasswordModalOpen: true,
            dialogOpen: true,
            deleteModalOpen: false
        });
    };

    _showDeleteDialog = (beneficiary, isContingent) => {
        this.setState({
            deleteModalOpen: true,
            shares: '',
            beneficiaryID: beneficiary.beneficiaryID,
            beneficiaryToRemoveID: beneficiary.beneficiaryID,
            isContingent
        });
    };

    _getCurrentBeneficiaries = () => {
        const beneficiaries = {
            primary: [],
            contingent: []
        };

        this.state.primary.map((beneficiary) => {
            if (beneficiary.beneficiaryID !== this.state.beneficiaryID) {
                beneficiaries.primary.push({
                    beneficiaryID: beneficiary.beneficiaryID,
                    firstname: beneficiary.firstname,
                    lastname: beneficiary.lastname,
                    relationship: beneficiary.relationship,
                    type: beneficiary.type,
                    birthdate: beneficiary.birthdate,
                    shares: Number(beneficiary.shares)
                });
            }

            return null;
        });

        this.state.contingent.map((beneficiary) => {
            if (beneficiary.beneficiaryID !== this.state.beneficiaryID) {
                beneficiaries.contingent.push({
                    beneficiaryID: beneficiary.beneficiaryID,
                    firstname: beneficiary.firstname,
                    lastname: beneficiary.lastname,
                    relationship: beneficiary.relationship,
                    type: beneficiary.type,
                    birthdate: beneficiary.birthdate,
                    shares: Number(beneficiary.shares)
                });
            }

            return null;
        });

        return beneficiaries;
    };

    /**
     * Called on save beneficiary
     * @private
     */
    _save = async () => {
        const isSignageValid = await this._validateSignageBlock();

        if (!isSignageValid) {
            return null;
        }

        // loop through the beneficiaries in state and get only the ones we are not currently editing
        const beneficiaries = await this._getCurrentBeneficiaries();

        const { firstname, lastname, shares, relationship, type, birthdate, beneficiaryID, password, signage } = this.state;

        // check if the password was provided
        const passwordError = await Services.validateInput('password', password);
        this.setState({ passwordError });

        if (passwordError) {
            return false;
        }

        let success = false;
        const data = {
            firstname,
            lastname,
            relationship: localizationMaps.toEnglish("relationships", relationship),
            type: localizationMaps.toEnglish("beneficiariesOptions", type),
            shares,
            birthdate: Services.dates.formatOutgoingDate(birthdate),
            password,
            signage: {
                ...signage,
                datedOn: Services.dates.formatOutgoingDate(this.state.signage.datedOn)
            }
        };

        if (this.state.isEdit) {
            success = await this.props.dispatch(editBeneficiary(beneficiaryID, data, beneficiaries, this.state.isContingent));
        } else {
            success = await this.props.dispatch(addBeneficiary(data, beneficiaries, this.state.isContingent));
        }

        if (success) {
            this.setState({
                isEdit: false,
                isContingent: false,
                dialogOpen: false,
                confirmPasswordModalOpen: false,
                signage: {
                    name: '',
                    signature: '',
                    acceptedTerms: false,
                    timestampOfAcceptance: null,
                    datedOn: null
                }
            });

            if (relationship !== 'Spouse') {
                this.setState({
                    hasSpouse: false
                });
            }

            return true;
        }

        return false;
    };

    _validateSignageBlock = async () => {
        const { signage, password } = this.state;

        const passwordError = await Services.validateInput('checkEmpty', password);
        let signageNameError = await Services.validateInput('checkEmpty', signage.name);
        const signageSignatureError = await Services.validateInput('checkEmpty', signage.signature);
        const signageDatedOnError = await Services.validateInput('date', signage.datedOn, i18n.locale);
        const signageAcceptedError = !signage.acceptedTerms;

        if (signageAcceptedError) {
            alert(i18n.t(tokens.labels.signage.pleaseAcceptAndAcknowledgeChanges));
            return null;
        }

        if (signage.name !== signage.signature) {
            signageNameError = i18n.t(tokens.labels.signage.signageNameError);
        }

        this.setState({
            signageNameError,
            signageSignatureError,
            signageDatedOnError,
            passwordError
        });

        if (
            signageNameError ||
            signageSignatureError ||
            signageDatedOnError ||
            passwordError
        ) {
            return false;
        }

        return true;
    };

    _remove = async () => {
        const isSignageValid = await this._validateSignageBlock();

        if (!isSignageValid) {
            return null;
        }

        // loop through the beneficiaries in state and get only the ones we are not currently editing
        const beneficiaries = await this._getCurrentBeneficiaries();
        const signage = {
            ...this.state.signage,
            datedOn: Services.dates.formatOutgoingDate(this.state.signage.datedOn)
        };

        const success = await this.props.dispatch(removeBeneficiary(
            this.state.beneficiaryToRemoveID,
            this.state.password,
            beneficiaries,
            signage,
            this.state.isContingent
        ));

        if (success) {
            this.setState({
                beneficiaryToRemoveID: false,
                dialogOpen: false,
                deleteModalOpen: false,
                isContingent: false
            });
        }

        return null;
    };

    render() {
        const { whitelabel } = this.props;
        const primary = this.state.primary;
        const contingent = this.state.contingent;

        const styles = {
            signature: {
                fontFamily: 'AntaraDistance',
                fontWeight: 'bold',
                fontSize: 20,
                paddingBottom: 0
            },
            currentBeneRow: {
                flexDirection: 'row'
            },
            titleBlock: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: 10
            },
            iconStyle: {
                padding: "12px",
                color: "#414042",
                '&.MuiButtonBase-root:hover': {
                    backgroundColor: Theme.colors.hoverGrey
                }
            }
        };

        return (
            <Container>
                <ContentSmall style={{ width: "60%" }}>
                    <Title title={ i18n.t(tokens.titles.beneficiaries) } />

                    <div>
                        <div id="beneficiaries" style={ styles.titleBlock }>
                            <Text mediumLarge>{ i18n.t(tokens.titles["primary beneficiaries"])}</Text>

                            <Button
                                testid="add-beneficiaries"
                                onClick={ () => this._openAddModal(false) }
                                transparent
                                customStyle={{ marginLeft: 'auto' }}
                            >
                                <AddIcon style={{ fontSize: 17, lineHeight: '14px', color: 'inherit', marginRight: 5 }} />
                                { i18n.t(tokens.buttons["add beneficiary"]) }
                            </Button>
                        </div>

                        {
                            primary.length === 0 ?
                                <Text testid="beneficiaries" light medium>{ i18n.t(tokens.labels.beneficiaries.youHaveNotDefinedAnyPrimaryBeneficiaries) }</Text>
                                :
                                primary.map((beneficiary, i) => (
                                    <PersonBlock
                                        testid={ i === 0 ? "primary" : undefined }
                                        key={beneficiary.beneficiaryID}
                                        firstname={beneficiary.firstname}
                                        lastname={beneficiary.lastname}
                                        relationship={ beneficiary.relationship }
                                        beneficiaryType={beneficiary.type}
                                        percentage={beneficiary.shares}
                                        dateAdded={beneficiary.dateAdded} 
                                        parentID={beneficiary.parentID}
                                        type="beneficiary"
                                        edit={() => this._openEditModal(beneficiary, false)}
                                        remove={() => this._showDeleteDialog(beneficiary, false)}
                                        iconCustomStyle={styles.iconStyle}
                                    />
                                ))
                        }
                    </div>

                    <div>
                        <div style={{ ...styles.titleBlock, marginTop: 30 }} > 
                            <Text mediumLarge>{ i18n.t(tokens.titles["contingent beneficiaries"])}</Text>

                            <Button
                                testid="add-beneficiaries"
                                onClick={ () => this._openAddModal(true) }
                                transparent
                                customStyle={{ marginLeft: 'auto' }}
                            >
                                <AddIcon style={{ fontSize: 17, lineHeight: '14px', color: 'inherit', marginRight: 5 }} />
                                { i18n.t(tokens.buttons["add contingent beneficiary"])}
                            </Button>
                        </div>

                        {
                            contingent.length === 0 ?
                                <Text testid="beneficiaries" light medium>{ i18n.t(tokens.labels.beneficiaries.youHaveNotDefinedAnyContingentBeneficiaries) }</Text>
                                :
                                contingent.map((beneficiary, i) => (
                                    <PersonBlock
                                        testid={ i === 0 ? "contingent" : undefined }
                                        key={beneficiary.beneficiaryID}
                                        firstname={beneficiary.firstname}
                                        lastname={beneficiary.lastname}
                                        relationship={beneficiary.relationship}
                                        beneficiaryType={beneficiary.type}
                                        percentage={beneficiary.shares}
                                        dateAdded={beneficiary.dateAdded}
                                        parentID={beneficiary.parentID}
                                        type="beneficiary"
                                        edit={() => this._openEditModal(beneficiary, true)}
                                        remove={() => this._showDeleteDialog(beneficiary, true)}
                                        iconCustomStyle={styles.iconStyle}
                                    />
                                ))
                        }
                    </div>

                    <FormModal
                        testid="add-edit-beneficiary-modal"
                        open={ this.state.dialogOpen }
                        close={this._close}
                        title={ this.state.confirmPasswordModalOpen ? i18n.t(tokens.titles["confirm changes"]) : this.state.isEdit ? i18n.t(tokens.titles["edit beneficiary"]) : `${ this.state.isContingent ? i18n.t(tokens.buttons["add contingent beneficiary"]) : i18n.t(tokens.titles["add beneficiary"]) }` }
                        disableBackdropClick
                        disableEscapeKeyDown
                        customContainerStyle={{ maxWidth: "500px" }}
                    >
                        {
                            this.state.confirmPasswordModalOpen ?
                                <React.Fragment>
                                    <Text
                                        align="left"
                                        medium
                                        display="inline-block"
                                        
                                    >
                                        { i18n.t(tokens.labels.account.confirmBeneficiaryChanges) }
                                    </Text>

                                    <TextInput
                                        label={ i18n.t(tokens.labels.password) }
                                        value={this.state.password}
                                        inputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {
                                                        this.state.visibility ?
                                                            <VisibilityIcon
                                                                style={{ cursor: "pointer", color: Theme.colors.darkGrey, marginRight: "8px" }}
                                                                onClick={this._toggleVisibility}
                                                            />
                                                            :
                                                            <VisibilityOffIcon
                                                                style={{ cursor: "pointer", color: Theme.colors.darkGrey, marginRight: "8px" }}
                                                                onClick={this._toggleVisibility}
                                                            />
                                                    }
                                                </InputAdornment>
                                            )
                                        }}
                                        onBlur={() => this._onBlur('password')}
                                        onChange={(value) => this._handleInputChange('password', value)}
                                        error={Boolean(this.state.passwordError)}
                                        helperText={this.state.passwordError}
                                        secure={!this.state.visibility}
                                        fullWidth
                                        autofocus
                                    />

                                    { /* SIGNAGE BLOCK HERE */ }
                                    <TextInput
                                        label={ i18n.t(tokens.labels.yourName) }
                                        fullWidth
                                        value={this.state.signage.name}
                                        onChange={(e) => this._handleSignageChange('name', e.target.value)}
                                        error={ this.state.signageNameError }
                                    />

                                    <TextInput
                                        label={ i18n.t(tokens.labels.signature) }
                                        fullWidth
                                        value={this.state.signage.signature}
                                        onChange={(e) => this._handleSignageChange('signature', e.target.value)}
                                        inputProps={{ inputProps: { style: { ...styles.signature } } }}
                                        error={ this.state.signageSignatureError }
                                    />

                                    <DateInput
                                        label={ i18n.t(tokens.labels.account.datedOnYYYYMMDD)}
                                        fullWidth
                                        value={this.state.signage.datedOn}
                                        onChange={(e) => this._handleSignageChange('datedOn', e.target.value)}
                                        error={ this.state.signageDatedOnError }
                                    />

                                    <FormGroup row style={{ marginTop: 20 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={ this.state.signage.acceptedTerms }
                                                    onChange={ () => this._handleSignageChange('acceptedTerms', !this.state.signage.acceptedTerms) }
                                                    value="acceptedTerms"
                                                    color="secondary"
                                                />
                                            }
                                            label={<Text avMedium>{ i18n.t(tokens.labels.account.acknowledgeInfoAccuracy)}</Text>}
                                        />
                                    </FormGroup>

                                    <Button
                                        onClick={this.state.beneficiaryToRemoveID ? this._remove : this._save}
                                        marginTop={5}
                                        color="primary"
                                        fullWidth
                                    >
                                        { i18n.t(tokens.buttons.finish) }
                                    </Button>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <TextInput
                                        label={ i18n.t(tokens.labels.firstname) }
                                        value={this.state.firstname}
                                        onBlur={() => this._onBlur('firstname')}
                                        onChange={(value) => this._handleInputChange('firstname', value)}
                                        error={Boolean(this.state.firstnameError)}
                                        helperText={this.state.firstnameError}
                                        fullWidth
                                    />

                                    <TextInput
                                        label={ i18n.t(tokens.labels.lastname) }
                                        value={this.state.lastname}
                                        onBlur={() => this._onBlur('lastname')}
                                        onChange={(value) => this._handleInputChange('lastname', value)}
                                        error={Boolean(this.state.lastnameError)}
                                        helperText={this.state.lastnameError}
                                        fullWidth
                                    />

                                    <TextInput
                                        label={ i18n.t(tokens.labels.relationship) }
                                        value={ this.state.relationship }
                                        fullWidth
                                        onBlur={() => this._onBlur('relationship')}
                                        onChange={(value) => this._handleSelectChange('relationship', value, this.state.beneficiaryID)}
                                        error={Boolean(this.state.relationshipError)}
                                        helperText={this.state.relationshipError}
                                        select
                                        selectOptions={ this.state.options }
                                    />

                                    <DateInput
                                        label={ i18n.t(tokens.labels.account.dateOfBirthYYYYMMDD) }
                                        value={this.state.birthdate}
                                        onBlur={() => this._onBlur('birthdate')}
                                        onChange={(value) => this._handleInputChange('birthdate', value)}
                                        error={Boolean(this.state.birthdateError)}
                                        helperText={this.state.birthdateError}
                                        fullWidth
                                    />

                                    <TextInput
                                        label={ i18n.t(tokens.labels.type) }
                                        value={this.state.type}
                                        fullWidth
                                        onBlur={() => this._onBlur('type')}
                                        onChange={(value) => this._handleSelectChange('type', value, this.state.beneficiaryID)}
                                        error={Boolean(this.state.typeError)}
                                        helperText={this.state.typeError}
                                        select
                                        selectOptions={ this.state.isContingent ? [ i18n.t(tokens.labels.beneficiaries.contingent) ] : Services.selectFieldOptions.beneficiariesOptions() }
                                    />

                                    <NumberInput
                                        label={ i18n.t(tokens.labels.beneficiaries.percentOfBenefits) }
                                        suffix="%"
                                        value={this.state.shares}
                                        onBlur={() => this._onBlur('shares')}
                                        onChange={(value) => this._handleInputChange('shares', value)}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                this._validateForm();
                                                e.preventDefault();
                                            }
                                        }}
                                        error={Boolean(this.state.sharesError)}
                                        helperText={this.state.sharesError}
                                        fullWidth
                                    />

                                    {
                                        this.state.isContingent ?
                                            <Text light small margin="20px 0 5px 0">
                                                { i18n.t(tokens.labels.beneficiaries.pleaseEnsureAllContingentBeneficiaries) }
                                            </Text>
                                            :
                                            <Text light small margin="20px 0 5px 0">
                                                { i18n.t(tokens.labels.beneficiaries.pleaseEnsureAllPrimaryBeneficiaries) }
                                            </Text>
                                    }

                                    {
                                        this.state.isContingent ?
                                            contingent.map((beneficiary) => {
                                                if (beneficiary.beneficiaryID === this.state.beneficiaryID) {
                                                    return null;
                                                }

                                                return (
                                                    <div key={beneficiary.beneficiaryID} style={styles.currentBeneRow}>
                                                        <NumberInput
                                                            label={beneficiary.firstname}
                                                            suffix="%"
                                                            value={ beneficiary.shares }
                                                            onChange={(event) => this._handleSharesChange(beneficiary.beneficiaryID, event)}
                                                            error={Boolean(this.state.sharesError)}
                                                            helperText={this.state.sharesError}
                                                            fullWidth
                                                        />
                                                    </div>
                                                );
                                            })
                                            :
                                            primary.map((beneficiary) => {
                                                if (beneficiary.beneficiaryID === this.state.beneficiaryID) {
                                                    return null;
                                                }

                                                return (
                                                    <div key={beneficiary.beneficiaryID} style={styles.currentBeneRow}>
                                                        <NumberInput
                                                            label={beneficiary.firstname}
                                                            suffix="%"
                                                            value={ beneficiary.shares }
                                                            onChange={(event) => this._handleSharesChange(beneficiary.beneficiaryID, event)}
                                                            error={Boolean(this.state.sharesError)}
                                                            helperText={this.state.sharesError}
                                                            fullWidth
                                                        />
                                                    </div>
                                                );
                                            })
                                    }

                                    <Button
                                        onClick={this._validateForm}
                                        marginTop={5}
                                        color="primary"
                                        fullWidth
                                    >
                                        { i18n.t(tokens.buttons["save beneficiary"])}
                                    </Button>
                                </React.Fragment>
                        }

                        {this.props.loading && <Loader whitelabel={ whitelabel } customImageStyle={{ top: '50%' }} />}
                    </FormModal>

                    {
                        this.state.deleteModalOpen &&
                            <FormModal
                                open={ this.state.deleteModalOpen }
                                close={this._close}
                                title={ i18n.t(tokens.titles["remove beneficiary"]) }
                                disableBackdropClick
                                disableEscapeKeyDown
                                onSave={ () => this._showConfirmPasswordDialog(true) }
                                customContainerStyle={{ maxWidth: "500px" }}
                            >
                                {
                                    this.state.isContingent ?
                                        <Text light small margin="20px 0 5px 0">
                                            { i18n.t(tokens.labels.beneficiaries.pleaseEnsureAllContingentBeneficiaries) }
                                        </Text>
                                        :
                                        <Text light small margin="20px 0 5px 0">
                                            { i18n.t(tokens.labels.beneficiaries.pleaseEnsureAllPrimaryBeneficiaries) }
                                        </Text>
                                }

                                {
                                    this.state.isContingent ?
                                        contingent.map((beneficiary) => {
                                            if (beneficiary.beneficiaryID === this.state.beneficiaryID) {
                                                return null;
                                            }

                                            return (
                                                <div key={beneficiary.beneficiaryID} style={styles.currentBeneRow}>
                                                    <NumberInput
                                                        label={beneficiary.firstname}
                                                        suffix="%"
                                                        value={ beneficiary.shares }
                                                        onChange={(event) => this._handleSharesChange(beneficiary.beneficiaryID, event)}
                                                        error={Boolean(this.state.sharesError)}
                                                        helperText={this.state.sharesError}
                                                        fullWidth
                                                    />
                                                </div>
                                            );
                                        })
                                        :
                                        primary.map((beneficiary) => {
                                            if (beneficiary.beneficiaryID === this.state.beneficiaryID) {
                                                return null;
                                            }

                                            return (
                                                <div key={beneficiary.beneficiaryID} style={styles.currentBeneRow}>
                                                    <NumberInput
                                                        label={beneficiary.firstname}
                                                        suffix="%"
                                                        value={ beneficiary.shares }
                                                        onChange={(event) => this._handleSharesChange(beneficiary.beneficiaryID, event)}
                                                        error={Boolean(this.state.sharesError)}
                                                        helperText={this.state.sharesError}
                                                        fullWidth
                                                    />
                                                </div>
                                            );
                                        })
                                }

                                {this.props.loading && <Loader whitelabel={ whitelabel } customImageStyle={{ top: '50%' }} />}
                            </FormModal>
                    }
                </ContentSmall>
            </Container>
        );
    }
}

Beneficiaries.propTypes = {
    loading: PropTypes.bool,
    primary: PropTypes.array,
    contingent: PropTypes.array,
    trustee: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.user.loading,
    primary: state.user.beneficiaries.primary,
    contingent: state.user.beneficiaries.contingent,
    trustee: state.user.trustee,
    whitelabel: state.whitelabel
});

export default (connect(mapStateToProps)(Beneficiaries));